import {CommonProps} from '@mui/material/OverridableComponent'
import styled from 'styled-components'

interface IConnectedCam {
  isOnline: boolean
}

interface InfoConfigCameraInterface {
  cursor?: string
  textDecoration?: string
}

interface DivInfoInterface {
  alingContent?: string
  width?: string
  display?: string
  alignItems?: string
  flexFlow?: string
}

export const TitleModalConfig = styled.p`
  font-size: 15px;
  text-align: center;
  font-weight: 500;
  color: #000000;
  padding: 4px 0 10px 0;
  @media (max-width: 767px) {
    font-size: 12px;
    padding: 0;
  }
`

export const TitleConfigCamera = styled.label`
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 10px;
`
export const MotionDetectionTitle = styled.label`
  font-size: 13px;
  font-weight: bold;
  margin-top: 20px;
`

export const ContainerGeneralData = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  @media (max-width: 869px) {
    flex-direction: column;
  }
`

export const ReactPlayerContainer = styled.div`
  display: flex;
  min-width: 750px;
  min-height: 420px;
  position: relative;

  @media (max-width: 869px) {
    min-width: 625px;
  }

  @media (max-width: 511px) {
    min-width: 435px;
  }

  @media (max-width: 400px) {
    min-width: 35px;
  }
`

export const InfoConfigCamera = styled.p<InfoConfigCameraInterface>`
  font-size: 13px;
  ${(props) => !!props.cursor && `cursor: ${props.cursor};`}
  color: ${({theme}) => theme.colors.primary};
  white-space: nowrap;
  ${(props) => !!props.textDecoration && `text-decoration: ${props.textDecoration};`};
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SxBoxModalTabs = {
  width: '100%',
  justifyContent: 'center',
  display: 'flex',
}

export const StyleTabsModal = {
  fontFamily: 'Inter',
  fontSize: '14px',
}

export const SxBoxCamViewConfig = {
  width: '1000px',
}

export const StyleGridViewConfig = {
  justifyContent: 'center',
  alignContent: 'center',
}

export const BoxButtonsTabConfig = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right',
  marginTop: '20px',
  marginBottom: '20px',
}

export const SxGridItemStatus = {
  textAlign: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

export const LabelTextStatus = styled.label`
  margin-top: 10px;
  font-weight: bold;
`

export const SxGridLineStatus = {
  display: 'flex',
  alignItems: 'center',
  maxWidth: ' 5.5%',
}

export const ConectedCamStatus = styled.div<IConnectedCam>`
  border-radius: 1.25em;
  padding: 5px 8px;
  color: white;
  background-color: ${(props) => (props.isOnline ? '#20bc30' : '#f44336')};
  transition: 0.3s;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 147px;
  padding-left: 10px;
`
export const CameraStatusLabel = styled.div<{status: string}>`
  border-radius: 1.25em;
  color: white;
  transition: 0.3s;
  cursor: default;
  font-size: 12px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  ${({status}) => status === 'ARMADO' && `background: green;`}
  ${({status}) => status === 'DESARMADO' && `background: red;`}
  ${({status}) => status === 'FORA DO HORÁRIO' && `background: orange;`}
`

export const ImageToSnapshot = styled.img`
  height: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const SnapshotImageError = styled.img`
  height: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  object-fit: contain;
`

export const ContainerStatusCamera = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1356px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`
export const DivInfo = styled.div<DivInfoInterface>`
  text-align: left;
  ${(props) => props.alingContent && `align-content: ${props.alingContent};`}
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.display && `display: ${props.display};`}
  ${(props) => props.alignItems && `align-items: ${props.alignItems};`}
  ${(props) => props.flexFlow && `flex-flow: ${props.flexFlow};`}

  @media (max-width: 869px) {
    max-width: 423px;
    display: flex;
    flex-direction: column;
  }
`

export const StyleItemCamEveryone = {
  width: '100%',
  padding: '12px',
}

export const StyleBoxItemCamEveryone: CommonProps['style'] = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'space-between',
}

export const StyleBoxItemCamSchedule: CommonProps['style'] = {
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'left',
}

export const SxBoxListSchedule = {
  borderRadius: 2,
  m: 2,
  height: '3em',
}

export const ButtonModalConfigEveryone = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 2.7em;
  width: 9em;
  border-radius: 5px;
  border: none;
  background: none;
  cursor: pointer;
  color: white;
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  background-color: #009eff;
  transition: 0.3s;
  margin-top: 16px;

  :disabled {
    opacity: 0.4;
    cursor: default;
    :hover {
      background-color: #009eff;
    }
  }
  :hover {
    background-color: #00639f;
  }
`
